import React from "react";
import { LogOut } from "lucide-react";
import { Button } from "../ui/button";

type HeaderSignOutButtonProps = {
  className: string;
  isMobile: boolean;
  onSignOut?: () => void;
};

export const HeaderSignOutButton: React.FC<HeaderSignOutButtonProps> = ({
  className,
  isMobile,
  onSignOut,
}) => {
  if (!onSignOut) {
    return null;
  }

  return (
    <Button
      type="button"
      variant="ghost"
      onClick={onSignOut}
      className={className}
    >
      <LogOut
        className={
          isMobile ? "w-5 h-5 mr-3 text-muted-foreground" : "w-4 h-4 mr-2"
        }
      />
      Sign out
    </Button>
  );
};
